import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { AccountTag } from 'app/entities/account-tag';
import { ApiResponse } from 'app/entities';

@Injectable({
    providedIn: 'root'
})
export class TagsService extends ApiService {

    findAll(params: any = {}) {
        params = this.paramsFromObject(params);
        return this.httpService.get('/v1/clients/tags', params).pipe(
            map(res => ApiResponse.parseWith(new AccountTag, res) as ApiResponse<AccountTag[]>)
        );
    }

    store(data: any): Observable<AccountTag> {
        return this.httpService.post('/v1/clients/tags', data).pipe(
            map(res => AccountTag.parse(res.data) as AccountTag)
        );
    }

    update(id: number, data: any): Observable<AccountTag> {
        return this.httpService.post(`/v1/clients/tags/${id}`, data).pipe(
            map(res => AccountTag.parse(res.data) as AccountTag)
        );
    }

    destroy(id: number): Observable<void> {
        return this.httpService.delete(`/v1/clients/tags/${id}`);
    }

}